module.exports = __webpack_public_path__ + "img/logo-06-06.b8cb49ee.png";